module.exports = __webpack_public_path__ + "img/car-rotate-small.ea6629e0.svg";